import type { IconGlyph } from '@sunwebgroup/uds-ui/icon'
import { createNewRelicLogger } from '@/scopes/common/infrastructure/logging/newRelicLogger'

const COMPONENT_NAME = 'resolveExtraIconGlyph'

const logger = createNewRelicLogger({ scope: 'booking-details' })

const DEFAULT_ICON: IconGlyph = 'PlusInSquare'

const GROUP_CODE_ICON_MAP: Record<string, IconGlyph> = {
  'CANCEL*': 'ShieldWithDismiss',
  'VISUMEGYPTE': 'DocumentWithText',
  'VISA*': 'DocumentWithText',
  'REBOOKSER': 'ArrowsSquarePath',
  'REBOOKING*': 'ArrowsSquarePath',
  'BABY*': 'Baby',
  'GF*': 'GolfClub',
  'GREENFEE': 'GolfClub',
  'PARK*': 'ParkingSign',
  'BIKE': 'Bike',
  'BRIDGE*': 'SpadeSymbol',
  'DINNERVOUCHER': 'ForkAndKnive',
  'MEAL-VOUCHERS': 'ForkAndKnive',
  'SPECBAG*': 'SuitcaseLargeBadgePlus',
  'FLIGHTFOOD*': 'ForkAndKnive',
  'BREAKFAST*': 'ForkAndKnive',
  'BAGA*': 'Suitcase',
  'SHUTTL*': 'BusRight',
  'DINERVOUCHER': 'ForkAndKnive',
  'SNOWCASE*': 'FlightTicket',
  'HALFBOARD*': 'ForkAndKnive',
}

// Default icon per extra `type`, used when no groupCode-specific override matches.
const TYPE_ICON_MAP: Record<string, IconGlyph> = {
  Luggage: 'Suitcase',
  Transfer: 'BusRight',
  SkiPass: 'SkiPass',
  SkiMaterial: 'Skis',
  SkiLesson: 'PersonSkiing',
  Insurance: 'SuitcaseOnWheelsWithCheckMark',
  CarRental: 'CarRight',
}

function matchGroupCodeIcon(groupCode: string): IconGlyph | undefined {
  for (const [pattern, icon] of Object.entries(GROUP_CODE_ICON_MAP)) {
    const isMatch = pattern.endsWith('*')
      ? groupCode.startsWith(pattern.slice(0, -1))
      : groupCode === pattern

    if (isMatch)
      return icon
  }

  return undefined
}

export function resolveExtraIconGlyph(type: string | undefined, groupCode: string | undefined): IconGlyph {
  const trimmedGroupCode = groupCode?.trim()
  const trimmedType = type?.trim()

  const groupCodeIcon = trimmedGroupCode ? matchGroupCodeIcon(trimmedGroupCode) : undefined
  if (groupCodeIcon)
    return groupCodeIcon

  const typeIcon = trimmedType ? TYPE_ICON_MAP[trimmedType] : undefined
  if (typeIcon)
    return typeIcon

  logger.logError(
    new Error(`Missing icon mapping for service: ${trimmedType ?? 'unknown'}, groupCode: ${trimmedGroupCode ?? 'unknown'}.`),
    {
      serviceName: trimmedType,
      groupCode: trimmedGroupCode,
      fallbackIconUsed: true,
      component: COMPONENT_NAME,
    },
  )

  return DEFAULT_ICON
}
